import ActionButton from 'components/ActionButton';
import ImageUploadComponent from 'components/ImageUploadComponent';
import React, { useState } from 'react';
import { createBanner, fetchUrlMetadata } from 'services';
import { imageurlToBase64, isValidURL, showError } from 'utils';
import styles from './index.module.scss';

const CreateBanner = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [urlMetadataLoading, setUrlMetadataLoading] = useState<boolean>(false);
  const [text, setText] = useState<string>('');
  const [url, setURL] = useState<string>('');
  const [image, setImage] = useState<string | File>();
  const [imageForPreview, setImageForPreview] = useState<string>('');
  const [active, setActive] = useState<boolean>(false);

  const createBannerFn = async () => {
    setLoading(true);
    const data = {
      text,
      url,
      image,
      active,
    };
    try {
      const response = await createBanner(data);
      props.history.replace(`/banners/${response.objectId}`);
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  const fetchUrlMetadataFn = async () => {
    try {
      setUrlMetadataLoading(true);
      const response = await fetchUrlMetadata(url);
      if (!text) {
        setText(response?.title);
      }
      if (!image && !imageForPreview && response?.image) {
        const base64String = await imageurlToBase64(response?.image) as string;
        setImageForPreview(base64String); 
      }
    } catch (e) {
      showError(e);
    } finally {
      setUrlMetadataLoading(false);
    }
  };

  const onImageUpload = (id, image) => {
    setImage(image);
    setImageForPreview(image?._url);
  };
  
  return (
    <>
      <div className={styles['main-container']}>
        <div className={styles['header']}>
          <div className={styles['heading']}>Create a New Banner</div>
        </div>
        <div className={styles['banner-details']}>
          <div className={styles['input-group']}>
            <div className={styles['image-container']}>
              <ImageUploadComponent
                src={imageForPreview.toString()}
                entityId={''}
                toggleModal={() => {}}
                uploadAPI={onImageUpload}
                onFileSelect={setImageForPreview}
                forceShowUploadButton
              />
            </div>
          </div>
          <div className={styles['inputs-section']}>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Text</div>
              <input
                className={'form-control'}
                disabled={loading}
                value={text}
                onChange={e => setText(e.target.value)}
              />
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>URL</div>
              <div className='d-flex'>
                <input
                  className={'form-control mr-2'}
                  disabled={loading}
                  value={url}
                  onChange={e => setURL(e.target.value)}
                  placeholder='https://blog.puertoricoproduce.com/recetas'
                />
                <ActionButton
                  text={'Fetch'}
                  active={isValidURL(url)}
                  isLoading={urlMetadataLoading}
                  onClick={fetchUrlMetadataFn}
                />
              </div>
            </div>
            <div className={styles['active-input-container']}>
              <input
                type={'checkbox'}
                disabled={loading}
                checked={active}
                onChange={e => setActive(e.target.checked)}
              />
              <div className={styles['active-label']}>Active</div>
            </div>
          </div>
        </div>
        <div className={styles['footer']}>
          <ActionButton
            text={'Cancel'}
            active={!loading}
            isLoading={false}
            onClick={() => props.history.goBack()}
            customClass={styles['cancel']}
          />
          <ActionButton
            text={'Create Banner'}
            active={!loading && !!image}
            isLoading={loading}
            onClick={createBannerFn}
          />
        </div>
      </div>
    </>
  );
};

export { CreateBanner };